import $ from 'jquery';

export default class ImageLightbox {
	constructor() {
		this.thumbnails = [];
		this.lightbox;
		this.elements = {
			galleryElements: $( '.ncst-gallery' ),
		};
	}

	/**
	 * Performs setup for this type of lightbox.
	 */
	init() {
		// Assign unique ID to any galleries and store
		for ( var i = 0; i < this.elements.galleryElements.length; i++ ) {
			this.elements.galleryElements[ i ].setAttribute(
				'data-pswp-uid',
				i + 1
			);
		}
	}

	setLightbox( $item, lightbox ) {
		this.lightbox = lightbox;
	}

	/**
	 * Retrieves all thumbnails that are handled by this type of lightbox.
	 *
	 * @return {jQuery obj} The jQuery object containing all matched thumbs.
	 */
	getThumbs() {
		this.thumbnails = $( 'a[data-fullsize]:has(img)' )
			.not( '.nolightbox' )
			.not( "[target='_blank']" )
			.filter( function () {
				return /\.(jp(e|g|eg)|png|gif|webp)(\?[^/]*)*$/i.test(
					$( this ).attr( 'href' )
				);
			} );

		return this.thumbnails;
	}

	/**
	 * Returns the options for an image lightbox.
	 *
	 * @param  {jQuery obj} $item The clicked <a> tag that triggered the lightbox.
	 * @return {obj}              PhotoSwipe options
	 */
	getOptions( $item ) {
		var options = {
			index: this.getClickedItemIndex( $item ),
			zoomEl: false,
			shareEl: false,
			maxSpreadZoom: 1,
			mainClass: 'pswp--minimal--dark',
			closeElClasses: [
				'item',
				'img',
				'caption',
				'zoom-wrap',
				'ui',
				'top-bar',
			],
			getDoubleTapZoom: function ( isMouseClick, item ) {
				return item.initialZoomLevel;
			},
			tapToClose: true,
			clickToCloseNonZoomable: true,
			getThumbBoundsFn: function ( index ) {
				// See Options -> getThumbBoundsFn section of documentation for more info
				var thumbnail = $item
						.get( 0 )
						.getElementsByTagName( 'img' )[ 0 ], // find thumbnail
					pageYScroll =
						window.pageYOffset ||
						document.documentElement.scrollTop,
					rect = thumbnail.getBoundingClientRect();

				return {
					x: rect.left,
					y: rect.top + pageYScroll,
					w: rect.width,
				};
			},
		};

		if ( ! $item.get( 0 ).hasAttribute( 'data-zoom' ) ) {
			options.hideAnimationDuration = 0;
			options.showAnimationDuration = 0;
		}

		return options;
	}

	/**
	 * Builds an array of PhotoSwipe items to create an image gallery from
	 * the clicked item.
	 *
	 * @param  {jQuery obj} $item The clicked <a> tag that triggered the lightbox.
	 * @return {array}.           Item array for PhotoSwipe.
	 */
	getItems( $item ) {
		var thumbElements = this.getGalleryThumbs( $item ),
			numNodes = thumbElements.length,
			items = [],
			$figureEl,
			$linkEl,
			$imgEl,
			size,
			item;

		for ( var i = 0; i < numNodes; i++ ) {
			$linkEl = $( thumbElements[ i ] ); // <a> element
			$figureEl = $linkEl.closest( 'figure' ); // <figure> element
			$imgEl = $linkEl.children( 'img' ).first();

			size = $linkEl.data( 'fullsize' ).split( 'x' );

			// create slide object
			item = {
				src: $linkEl.attr( 'href' ),
				w: parseInt( size[ 0 ], 10 ),
				h: parseInt( size[ 1 ], 10 ),
			};

			if ( $figureEl.children().length > 1 ) {
				// <figcaption> content
				item.title = $figureEl.children( 'figcaption' ).html();
			}

			if (
				$imgEl.length > 0 &&
				$linkEl.get( 0 ).hasAttribute( 'data-zoom' )
			) {
				// <img> thumbnail element, retrieving thumbnail url
				item.msrc = $imgEl.attr( 'src' );
			}

			items.push( item );
		}

		return items;
	}

	/**
	 * Filters the array of thumbnails to only those that
	 * belong to the given gallery element. If the given element
	 * is not a gallery, an array containing only that element is
	 * returned.
	 *
	 * @param  {jQuey obj} $item The clicked <a> tag that triggered the lightbox.
	 * @return {array}           An array of thumbnail elements.
	 */
	getGalleryThumbs( $item ) {
		// Look for a parent gallery
		var $gallery = $item.closest( '[data-pswp-uid]' );

		// Item is in a gallery, so return its sibiling thumbs
		if ( $gallery.length > 0 ) {
			return this.thumbnails.filter( function () {
				return (
					$( this ).closest( '[data-pswp-uid]' ).get( 0 ) ==
					$gallery.get( 0 )
				);
			} );
		}

		// Item is not in a gallery
		return [ $item.get( 0 ) ];
	}

	/**
	 * Gets the index of the clicked item in context of its containing gallery.
	 * Items that are not in a gallery always return 0.
	 *
	 * @param  {jQuery obj} $item The clicked <a> tag that triggered the lightbox.
	 * @return {Integer}          The index of the item in its containing gallery.
	 */
	getClickedItemIndex( $item ) {
		var thumbElements = this.getGalleryThumbs( $item ),
			numNodes = thumbElements.length,
			nodeIndex = 0,
			openTo = 0;

		for ( var i = 0; i < numNodes; i++ ) {
			if ( thumbElements[ i ] === $item.get( 0 ) ) {
				openTo = nodeIndex;
				break;
			}
			nodeIndex++;
		}

		return openTo;
	}
}
